const absoluteUrlPattern = /^https?:\/\//i;

export const resolveResourceBasePath = (basePath: string, servicePath: string): string =>
  absoluteUrlPattern.test(servicePath) ? servicePath : `${basePath}${servicePath}`;
